<!--
 * @Description: 泵送剂模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:05:36
-->
<template>
  <div id="template7" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="7"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_06 }}</td>
        <td>车牌号</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>PH值</td>
        <td :class="{ bg5: !isViewResult }"><el-input v-model="formData.cell_17.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td>密度（g/cm³）</td>
        <td :class="{ bg5: !isViewResult }"><el-input v-model="formData.cell_18.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td>初始净浆流动度（mm）</td>
        <td :class="{ bg5: !isViewResult }"><el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
        <td>1h后净浆流动度</td>
        <td :class="{ bg5: !isViewResult }"><el-input v-model="formData.cell_20.resultValue" placeholder="请输入" :readonly="isViewResult" /></td>
      </tr>
      <tr>
        <td>混凝土加水时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="8">
          <el-date-picker v-model="formData.cell_43_p01.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>试验期龄</td>
        <td colspan="4">7天</td>
        <td colspan="4">28天</td>
      </tr>
      <tr>
        <td>强度项目</td>
        <td colspan="2">强度</td>
        <td colspan="2">强度平均值</td>
        <td colspan="2">强度</td>
        <td colspan="2">强度平均值</td>
      </tr>
      <tr>
        <td rowspan="3">抗压（Mpa）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_24.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="3">{{ formData.cell_27.resultValue }}</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_28.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="3">{{ formData.cell_31.resultValue }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_29.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_30.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>基准混凝土</td>
        <td>7天强度（Mpa）</td>
        <!--                <td :class="{bg3: !isViewResult}">-->
        <!--                    <el-input v-model="tableData.jzhntqd7" placeholder="请输入"  :readonly="isViewResult"/>-->
        <!--                </td>-->
        <td :class="{ bg2: !isViewResult }" @click="setData('cell_32')">{{ formData.cell_32.resultValue || "请配置" }}</td>
        <td colspan="2">28天强度（Mpa）</td>
        <!--                <td :class="{bg3: !isViewResult}">-->
        <!--                    <el-input v-model="tableData.jzhntqd28" placeholder="请输入"  :readonly="isViewResult"/>-->
        <!--                </td>-->
        <td :class="{ bg2: !isViewResult }" @click="setData('cell_33')">{{ formData.cell_33.resultValue || "请配置" }}</td>
        <td>初始净浆流动度</td>
        <td :class="formData.cell_34? formData.cell_34.clsObj: ''" colspan="2">
          <el-input :v-model="formData.cell_34? formData.cell_34.resultValue: 0" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="5">检测结果</td>
        <td>7天抗压强度比（%）</td>
        <td :class="formData.cell_35? formData.cell_35.clsObj: ''">
          {{ formData.cell_35.resultValue }}
          <el-tooltip v-if="formData.cell_35.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_35.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td colspan="2">28天抗压强度比（%）</td>
        <td :class="formData.cell_36? formData.cell_36.clsObj: ''">
          {{ formData.cell_36.resultValue }}
          <el-tooltip v-if="formData.cell_36.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_36.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>1h后净浆流动度</td>
        <td :class="formData.cell_37.clsObj" colspan="2">
          <el-input v-model="formData.cell_37.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>密度（g/cm³）</td>
        <td :class="formData.cell_38.clsObj">
          <el-input v-model="formData.cell_38.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td colspan="2">PH值</td>
        <td :class="formData.cell_39.clsObj">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>2h后净浆流动度</td>
        <td :class="formData.cell_40.clsObj" colspan="2">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>初凝时间（min）</td>
        <td :class="formData.cell_41_11.clsObj" @click="setData('cell_41')">{{ formData.cell_41_11.resultValue || "请配置" }}</td>
        <td colspan="2">含固量（%）</td>
        <td :class="formData.cell_42_p03.clsObj" @click="setData('cell_42')">{{ formData.cell_42_p03.resultValue || "请配置" }}</td>
        <td>1h经时损失（mm）</td>
        <td :class="formData.cell_43_p11.clsObj" colspan="2" @click="setData('cell_43')">{{ formData.cell_43_p11.resultValue || "请配置" }}</td>
      </tr>
      <tr>
        <td>终凝时间（min）</td>
        <td :class="formData.cell_44_11? formData.cell_44_11.clsObj: ''" @click="setData('cell_44')">{{ formData.cell_44_11? formData.cell_44_11.resultValue: 0 || "请配置" }}</td>
        <td colspan="2">28天收缩率比（%）</td>
        <td :class="formData.cell_45.clsObj" @click="setData('cell_45')">{{ formData.cell_45.resultValue || "请配置" }}</td>
        <td>含气量（%）</td>
        <td :class="formData.cell_46_p04.clsObj" colspan="2" @click="setData('cell_46')">{{ formData.cell_46_p04.resultValue || "请配置" }}</td>
      </tr>
      <tr>
        <td>胶砂减水率（%）</td>
        <td :class="formData.cell_47_p10.clsObj" @click="setData('cell_47')">{{ formData.cell_47_p10.resultValue || "请配置" }}</td>
        <td colspan="2">混凝土减水率（%）</td>
        <td :class="formData.cell_48_p10.clsObj" @click="setData('cell_48')">{{ formData.cell_48_p10.resultValue || "请配置" }}</td>
        <td>泌水率比（%）</td>
        <td :class="formData.cell_49_p33.clsObj" colspan="2" @click="setData('cell_49')">{{ formData.cell_49_p33.resultValue || "请配置" }}</td>
      </tr>
      <tr>
        <td rowspan="2">备 注</td>
        <td rowspan="2" colspan="8">
          <el-input v-model="formData.cell_50.resultValue" type="textarea" :rows="2" :readonly="isViewResult" />
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>

<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },

  cell_17: { key: "phz", title: "PH值", category: 7, type: 2, resultValue: "", verify: "请配置PH值" },
  cell_18: { key: "md", title: "密度（g/cm3）", category: 7, type: 2, resultValue: "", verify: "请配置密度" },
  cell_19: { key: "csjjldd", title: "初始净浆流动度（mm）", category: 7, type: 2, resultValue: "", verify: "请配置初始净浆流动度" },
  cell_20: { key: "1hhjjldd", title: "1h后净浆流动度（mm）", category: 7, type: 2, resultValue: "", verify: "请配置1h后净浆流动度" },

  cell_43_p01: { resultValue: "", key: "hntjssj", title: "混凝土加水时间", category: 6, type: 3, code: "cell_43_p01" },

  cell_24: { resultValue: "", key: "kyqd7_1", title: "抗压强度7天", category: 6, type: 3, code: "cell_24" },
  cell_25: { resultValue: "", key: "kyqd7_2", title: "抗压强度7天", category: 6, type: 3, code: "cell_25" },
  cell_26: { resultValue: "", key: "kyqd7_3", title: "抗压强度7天", category: 6, type: 3, code: "cell_26" },
  cell_28: { resultValue: "", key: "kyqd28_1", title: "抗压强度28天", category: 6, type: 3, code: "cell_28" },
  cell_29: { resultValue: "", key: "kyqd28_2", title: "抗压强度28天", category: 6, type: 3, code: "cell_29" },
  cell_30: { resultValue: "", key: "kyqd28_3", title: "抗压强度28天", category: 6, type: 3, code: "cell_30" },

  cell_32_p01: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd7_1", title: "基准混凝土7天强度1", category: 6, type: 3, code: "cell_32_p01" },
  cell_32_p02: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd7_2", title: "基准混凝土7天强度2", category: 6, type: 3, code: "cell_32_p02" },
  cell_32_p03: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd7_3", title: "基准混凝土7天强度3", category: 6, type: 3, code: "cell_32_p03" },
  cell_32: { unit: "g", valType: "calc", resultValue: "", key: "jzhntqd7", title: "基准混凝土7天强度", category: 6, type: 3, code: "cell_32" },
  cell_33_p01: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd28_1", title: "基准混凝土28天强度1", category: 6, type: 3, code: "cell_33_p01" },
  cell_33_p02: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd28_2", title: "基准混凝土28天强度2", category: 6, type: 3, code: "cell_33_p02" },
  cell_33_p03: { unit: "g", valType: "input", resultValue: "", key: "jzhntqd28_3", title: "基准混凝土28天强度3", category: 6, type: 3, code: "cell_33_p03" },
  cell_33: { unit: "g", valType: "calc", resultValue: "", key: "jzhntqd28", title: "基准混凝土28天强度", category: 6, type: 3, code: "cell_33" },

  cell_34: { resultValue: "", key: "csldd0", title: "初始流动度", category: 2, type: 3, code: "cell_34", clsObj: { bg2: true } },
  cell_37: { resultValue: "", key: "csldd1", title: "1h后流动度", category: 2, type: 3, code: "cell_37", clsObj: { bg2: true } },
  cell_40: { resultValue: "", key: "csldd2", title: "2h后流动度", category: 2, type: 3, code: "cell_40", clsObj: { bg2: true } },

  cell_38: { resultValue: "", key: "md", title: "密度", category: 2, type: 3, code: "cell_38", clsObj: { bg2: true } },
  cell_39: { resultValue: "", key: "PHz", title: "PH值", category: 2, type: 3, code: "cell_39", clsObj: { bg2: true } },

  cell_41_01: { unit: "", valType: "date", resultValue: "", key: "cnsjsjjssj", title: "受检混凝土加水时间", category: 6, type: 3, code: "cell_41_01" },
  cell_41_02: { unit: "", valType: "date", resultValue: "", key: "cnsjjzjssj", title: "基准混凝土加水时间", category: 6, type: 3, code: "cell_41_02" },
  cell_41_03: { unit: "min", valType: "input", resultValue: "", key: "sjcnsj1", title: "受检混凝土初凝时间", category: 6, type: 3, code: "cell_41_03" },
  cell_41_04: { unit: "min", valType: "input", resultValue: "", key: "jzcnsj1", title: "基准混凝土初凝时间", category: 6, type: 3, code: "cell_41_04" },
  cell_41_05: { unit: "min", valType: "input", resultValue: "", key: "sjcnsj2", title: "受检混凝土初凝时间", category: 6, type: 3, code: "cell_41_05" },
  cell_41_06: { unit: "min", valType: "input", resultValue: "", key: "jzcnsj2", title: "基准混凝土初凝时间", category: 6, type: 3, code: "cell_41_06" },
  cell_41_07: { unit: "min", valType: "input", resultValue: "", key: "sjcnsj3", title: "受检混凝土初凝时间", category: 6, type: 3, code: "cell_41_07" },
  cell_41_08: { unit: "min", valType: "input", resultValue: "", key: "jzcnsj3", title: "基准混凝土初凝时间", category: 6, type: 3, code: "cell_41_08" },
  cell_41_09: { unit: "min", valType: "calc", resultValue: "", key: "sjcnsj", title: "受检混凝土初凝时间平均值", category: 6, type: 3, code: "cell_41_09" },
  cell_41_10: { unit: "min", valType: "calc", resultValue: "", key: "jzcnsj", title: "基准混凝土初凝时间平均值", category: 6, type: 3, code: "cell_41_10" },
  cell_41_11: { unit: "min", valType: "calc", resultValue: "", key: "cnsj", title: "初凝时间", category: 1, type: 2, code: "cell_41_11", clsObj: { bg2: true } },

  //todo 下面三条编码重复
  // cell_41_01:{resultValue: '', key: 'znsjsjjssj', title: '受检混凝土加水时间', category: 6, type: 3, code: 'cell_41_01'},
  // cell_41_02:{resultValue: '', key: 'znsjjzjssj', title: '基准混凝土加水时间', category: 6, type: 3, code: 'cell_41_02'},
  // cell_44_03: { resultValue: "", key: "sjznsj1", title: "受检混凝土终凝时间", category: 6, type: 3, code: "cell_41_03" },
  cell_44_03: { unit: "min", valType: "input", resultValue: "", key: "sjznsj1", title: "受检混凝土终凝时间", category: 6, type: 3, code: "cell_41_01" },
  cell_44_04: { unit: "min", valType: "input", resultValue: "", key: "jzznsj1", title: "基准混凝土终凝时间", category: 6, type: 3, code: "cell_44_04" },
  cell_44_05: { unit: "min", valType: "input", resultValue: "", key: "sjznsj2", title: "受检混凝土终凝时间", category: 6, type: 3, code: "cell_44_05" },
  cell_44_06: { unit: "min", valType: "input", resultValue: "", key: "jzznsj2", title: "基准混凝土终凝时间", category: 6, type: 3, code: "cell_44_06" },
  cell_44_07: { unit: "min", valType: "input", resultValue: "", key: "sjznsj3", title: "受检混凝土终凝时间", category: 6, type: 3, code: "cell_44_07" },
  cell_44_08: { unit: "min", valType: "input", resultValue: "", key: "jzznsj3", title: "基准混凝土终凝时间", category: 6, type: 3, code: "cell_44_08" },
  cell_44_09: { unit: "min", valType: "calc", resultValue: "", key: "sjznsj", title: "受检混凝土终凝时间平均值", category: 6, type: 3, code: "cell_44_09" },
  cell_44_10: { unit: "min", valType: "calc", resultValue: "", key: "jzznsj", title: "基准混凝土终凝时间平均值", category: 6, type: 3, code: "cell_44_10" },
  cell_44_11: { unit: "min", valType: "calc", resultValue: "", key: "znsj", title: "终凝时间", category: 1, type: 2, code: "cell_44_11", clsObj: { bg2: true } },

  cell_47_p01: { unit: "ml", valType: "input", resultValue: "", key: "jzjsdwysl1", title: "基准胶砂单位用水量1", category: 6, type: 3, code: "cell_47_p01" },
  cell_47_p02: { unit: "kg/m³", valType: "input", resultValue: "", key: "sjjsdwysl1", title: "受检胶砂单位用水量1", category: 6, type: 3, code: "cell_47_p02" },
  cell_47_p03: { unit: "", valType: "calc", resultValue: "", key: "jsljs1", title: "减水率1", category: 6, type: 3, code: "cell_47_p03" },
  cell_47_p04: { unit: "ml", valType: "input", resultValue: "", key: "jzjsdwysl2", title: "基准胶砂单位用水量2", category: 6, type: 3, code: "cell_47_p04" },
  cell_47_p05: { unit: "kg/m³", valType: "input", resultValue: "", key: "sjjsdwysl2", title: "受检胶砂单位用水量2", category: 6, type: 3, code: "cell_47_p05" },
  cell_47_p06: { unit: "", valType: "calc", resultValue: "", key: "jsljs2", title: "减水率2", category: 6, type: 3, code: "cell_47_p06" },
  cell_47_p07: { unit: "ml", valType: "input", resultValue: "", key: "jzjsdwysl3", title: "基准胶砂单位用水量3", category: 6, type: 3, code: "cell_47_p07" },
  cell_47_p08: { unit: "kg/m³", valType: "input", resultValue: "", key: "sjjsdwysl3", title: "受检胶砂单位用水量3", category: 6, type: 3, code: "cell_47_p08" },
  cell_47_p09: { unit: "", valType: "calc", resultValue: "", key: "jsljs3", title: "减水率3", category: 6, type: 3, code: "cell_47_p09" },
  cell_47_p10: { unit: "", valType: "calc", resultValue: "", key: "jsjsl", title: "胶砂减水率", category: 2, type: 3, code: "cell_47_p10", clsObj: { bg2: true } },

  cell_48_p01: { unit: "ml", valType: "input", resultValue: "", key: "jzhntdwysl1", title: "基准混凝土单位用水量1", category: 6, type: 3, code: "cell_48_p01" },
  cell_48_p02: { unit: "ml", valType: "input", resultValue: "", key: "sjhntdwysl1", title: "受检混凝土单位用水量1", category: 6, type: 3, code: "cell_48_p02" },
  cell_48_p03: { unit: "", valType: "calc", resultValue: "", key: "jslhnt1", title: "减水率1", category: 6, type: 3, code: "cell_48_p03" },
  cell_48_p04: { unit: "ml", valType: "input", resultValue: "", key: "jzhntdwysl2", title: "基准混凝土单位用水量2", category: 6, type: 3, code: "cell_48_p04" },
  cell_48_p05: { unit: "ml", valType: "input", resultValue: "", key: "sjhntdwysl2", title: "受检混凝土单位用水量2", category: 6, type: 3, code: "cell_48_p05" },
  cell_48_p06: { unit: "", valType: "calc", resultValue: "", key: "jslhnt2", title: "减水率2", category: 6, type: 3, code: "cell_48_p06" },
  cell_48_p07: { unit: "ml", valType: "input", resultValue: "", key: "jzhntdwysl3", title: "基准混凝土单位用水量3", category: 6, type: 3, code: "cell_48_p07" },
  cell_48_p08: { unit: "ml", valType: "input", resultValue: "", key: "sjhntdwysl3", title: "受检混凝土单位用水量3", category: 6, type: 3, code: "cell_48_p08" },
  cell_48_p09: { unit: "", valType: "calc", resultValue: "", key: "jslhnt3", title: "减水率3", category: 6, type: 3, code: "cell_48_p09" },
  cell_48_p10: { unit: "", valType: "calc", resultValue: "", key: "hntjsl", title: "混凝土减水率", category: 2, type: 3, code: "cell_48_p10", clsObj: { bg2: true } },

  cell_43_p02: { unit: "mm", valType: "input", resultValue: "", key: "cstld1", title: "初始坍落度1", category: 6, type: 3, code: "cell_43_p02" },
  cell_43_p03: { unit: "mm", valType: "input", resultValue: "", key: "onetld1", title: "1h后坍落度1", category: 6, type: 3, code: "cell_43_p03" },
  cell_43_p04: { unit: "", valType: "calc", resultValue: "", key: "jsbhl1", title: "经时变化量1", category: 6, type: 3, code: "cell_43_p04" },
  cell_43_p05: { unit: "mm", valType: "input", resultValue: "", key: "cstld2", title: "初始坍落度2", category: 6, type: 3, code: "cell_43_p05" },
  cell_43_p06: { unit: "mm", valType: "input", resultValue: "", key: "onetld2", title: "1h后坍落度2", category: 6, type: 3, code: "cell_43_p06" },
  cell_43_p07: { unit: "", valType: "calc", resultValue: "", key: "jsbhl2", title: "经时变化量2", category: 6, type: 3, code: "cell_43_p07" },
  cell_43_p08: { unit: "mm", valType: "input", resultValue: "", key: "cstld3", title: "初始坍落度3", category: 6, type: 3, code: "cell_43_p08" },
  cell_43_p09: { unit: "mm", valType: "input", resultValue: "", key: "onetld3", title: "1h后坍落度3", category: 6, type: 3, code: "cell_43_p09" },
  cell_43_p10: { unit: "", valType: "calc", resultValue: "", key: "jsbhl3", title: "经时变化量3", category: 6, type: 3, code: "cell_43_p10" },
  cell_43_p11: { unit: "", valType: "calc", resultValue: "", key: "jsss", title: "1h经时损失", category: 2, type: 3, code: "cell_43_p11", clsObj: { bg2: true } },

  cell_49_p01: { unit: "g", valType: "input", resultValue: "", key: "sjhntmszzl1", title: "受检混凝土泌水总质量1", category: 6, type: 3, code: "cell_49_p01" },
  cell_49_p02: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwysl1", title: "受检混凝土拌合物用水量1", category: 6, type: 3, code: "cell_49_p02" },
  cell_49_p03: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwzzl1", title: "受检混凝土拌合物总质量1", category: 6, type: 3, code: "cell_49_p03" },
  cell_49_p04: { unit: "g", valType: "input", resultValue: "", key: "sjsyzl1", title: "受检试样质量1", category: 6, type: 3, code: "cell_49_p04" },
  cell_49_p05: { unit: "", valType: "calc", resultValue: "", key: "sjhntmsl1", title: "受检混凝土泌水率1", category: 6, type: 3, code: "cell_49_p05" },
  cell_49_p06: { unit: "g", valType: "input", resultValue: "", key: "sjhntmszzl2", title: "受检混凝土泌水总质量2", category: 6, type: 3, code: "cell_49_p06" },
  cell_49_p07: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwysl2", title: "受检混凝土拌合物用水量2", category: 6, type: 3, code: "cell_49_p07" },
  cell_49_p08: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwzzl2", title: "受检混凝土拌合物总质量2", category: 6, type: 3, code: "cell_49_p08" },
  cell_49_p09: { unit: "g", valType: "input", resultValue: "", key: "sjsyzl2", title: "受检试样质量2", category: 6, type: 3, code: "cell_49_p09" },
  cell_49_p10: { unit: "", valType: "calc", resultValue: "", key: "sjhntmsl2", title: "受检混凝土泌水率2", category: 6, type: 3, code: "cell_49_p10" },
  cell_49_p11: { unit: "g", valType: "input", resultValue: "", key: "sjhntmszzl3", title: "受检混凝土泌水总质量3", category: 6, type: 3, code: "cell_49_p11" },
  cell_49_p12: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwysl3", title: "受检混凝土拌合物用水量3", category: 6, type: 3, code: "cell_49_p12" },
  cell_49_p13: { unit: "g", valType: "input", resultValue: "", key: "sjhntbhwzzl3", title: "受检混凝土拌合物总质量3", category: 6, type: 3, code: "cell_49_p13" },
  cell_49_p14: { unit: "g", valType: "input", resultValue: "", key: "sjsyzl3", title: "受检试样质量3", category: 6, type: 3, code: "cell_49_p14" },
  cell_49_p15: { unit: "", valType: "calc", resultValue: "", key: "sjhntmsl3", title: "受检混凝土泌水率3", category: 6, type: 3, code: "cell_49_p15" },
  cell_49_p16: { unit: "", valType: "calc", resultValue: "", key: "sjhntmsl", title: "受检混凝土泌水率", category: 6, type: 3, code: "cell_49_p16" },
  cell_49_p17: { unit: "g", valType: "input", resultValue: "", key: "jzhntmszzl1", title: "基准混凝土泌水总质量1", category: 6, type: 3, code: "cell_49_p17" },
  cell_49_p18: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwysl1", title: "基准混凝土拌合物用水量1", category: 6, type: 3, code: "cell_49_p18" },
  cell_49_p19: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwzzl1", title: "基准混凝土拌合物总质量1", category: 6, type: 3, code: "cell_49_p19" },
  cell_49_p20: { unit: "g", valType: "input", resultValue: "", key: "jzsyzl1", title: "基准试样质量1", category: 6, type: 3, code: "cell_49_p20" },
  cell_49_p21: { unit: "", valType: "calc", resultValue: "", key: "jzhntmsl1", title: "基准混凝土泌水率1", category: 6, type: 3, code: "cell_49_p21" },
  cell_49_p22: { unit: "g", valType: "input", resultValue: "", key: "jzhntmszzl2", title: "基准混凝土泌水总质量2", category: 6, type: 3, code: "cell_49_p22" },
  cell_49_p23: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwysl2", title: "基准混凝土拌合物用水量2", category: 6, type: 3, code: "cell_49_p23" },
  cell_49_p24: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwzzl2", title: "基准混凝土拌合物总质量2", category: 6, type: 3, code: "cell_49_p24" },
  cell_49_p25: { unit: "g", valType: "input", resultValue: "", key: "jzsyzl2", title: "基准试样质量2", category: 6, type: 3, code: "cell_49_p25" },
  cell_49_p26: { unit: "", valType: "calc", resultValue: "", key: "jzhntmsl2", title: "基准混凝土泌水率2", category: 6, type: 3, code: "cell_49_p26" },
  cell_49_p27: { unit: "g", valType: "input", resultValue: "", key: "jzhntmszzl3", title: "基准混凝土泌水总质量3", category: 6, type: 3, code: "cell_49_p27" },
  cell_49_p28: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwysl3", title: "基准混凝土拌合物用水量3", category: 6, type: 3, code: "cell_49_p28" },
  cell_49_p29: { unit: "g", valType: "input", resultValue: "", key: "jzhntbhwzzl3", title: "基准混凝土拌合物总质量3", category: 6, type: 3, code: "cell_49_p29" },
  cell_49_p30: { unit: "g", valType: "input", resultValue: "", key: "jzsyzl3", title: "基准试样质量3", category: 6, type: 3, code: "cell_49_p30" },
  cell_49_p31: { unit: "", valType: "calc", resultValue: "", key: "jzhntmsl3", title: "基准混凝土泌水率3", category: 6, type: 3, code: "cell_49_p31" },
  cell_49_p32: { unit: "", valType: "calc", resultValue: "", key: "jzhntmsl", title: "基准混凝土泌水率", category: 6, type: 3, code: "cell_49_p32" },
  cell_49_p33: { unit: "", valType: "calc", resultValue: "", key: "mslb", title: "泌水率比", category: 2, type: 3, code: "cell_49_p33", clsObj: { bg2: true } },

  cell_46_p01: { unit: "", valType: "input", resultValue: "", key: "hql1", title: "含气量1", category: 6, type: 3, code: "cell_46_p01" },
  cell_46_p02: { unit: "", valType: "input", resultValue: "", key: "hql2", title: "含气量2", category: 6, type: 3, code: "cell_46_p02" },
  cell_46_p03: { unit: "", valType: "input", resultValue: "", key: "hql3", title: "含气量3", category: 6, type: 3, code: "cell_46_p03" },
  cell_46_p04: { unit: "", valType: "calc", resultValue: "", key: "hql", title: "含气量", category: 2, type: 3, code: "cell_46_p04", clsObj: { bg2: true } },

  cell_42_p01: { unit: "g", valType: "input", resultValue: "", key: "ytsyzl", title: "液体试样质量", category: 6, type: 3, code: "cell_42_p01" },
  cell_42_p02: { unit: "g", valType: "input", resultValue: "", key: "hghzl", title: "烘干后质量", category: 6, type: 3, code: "cell_42_p02" },
  cell_42_p03: { unit: "", valType: "calc", resultValue: "", key: "hgl", title: "含固量", category: 2, type: 3, code: "cell_42_p03", clsObj: { bg2: true } },

  cell_45_p01: { unit: "", valType: "input", resultValue: "", key: "sjssl1", title: "受检收缩率1", category: 6, type: 3, code: "cell_45_p01" },
  cell_45_p02: { unit: "", valType: "input", resultValue: "", key: "sjssl2", title: "受检收缩率2", category: 6, type: 3, code: "cell_45_p02" },
  cell_45_p03: { unit: "", valType: "input", resultValue: "", key: "sjssl3", title: "受检收缩率3", category: 6, type: 3, code: "cell_45_p03" },
  cell_45_p04: { unit: "", valType: "calc", resultValue: "", key: "sjsslpjz", title: "受检收缩率平均值", category: 6, type: 3, code: "cell_45_p04" },
  cell_45_p05: { unit: "", valType: "input", resultValue: "", key: "jzssl1", title: "基准收缩率1", category: 6, type: 3, code: "cell_45_p05" },
  cell_45_p06: { unit: "", valType: "input", resultValue: "", key: "jzssl2", title: "基准收缩率2", category: 6, type: 3, code: "cell_45_p06" },
  cell_45_p07: { unit: "", valType: "input", resultValue: "", key: "jzssl3", title: "基准收缩率3", category: 6, type: 3, code: "cell_45_p07" },
  cell_45_p08: { unit: "", valType: "calc", resultValue: "", key: "jzsslpjz", title: "基准收缩率平均值", category: 6, type: 3, code: "cell_45_p08" },
  cell_45: { unit: "", valType: "calc", resultValue: "", key: "sslb28", title: "28天收缩率比", category: 2, type: 3, code: "cell_45", clsObj: { bg2: true } },

  cell_50: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_50" },
  // 以下为计算属性
  cell_27: { resultValue: "", key: "kyqd7", title: "抗压强度7天平均值", category: 6, type: 3, code: "cell_27" },
  cell_31: { resultValue: "", key: "kyqd28", title: "抗压强度28天平均值", category: 6, type: 3, code: "cell_31" },
  cell_35: { resultValue: "", key: "kyqdb7", title: "抗压强度比7天", category: 1, type: 3, code: "cell_35", clsObj: { bg1: true } },
  cell_36: { resultValue: "", key: "kyqdb28", title: "抗压强度比28天", category: 1, type: 3, code: "cell_36", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 7d抗压强度比
      if (this.hasValues([27, 32])) {
        val = Math.round((this.getFieldVal(27) / this.getFieldVal(32)) * 100);
      }
      this.setFieldVal(35, val);
      val = "";
      // 21d抗压强度比
      if (this.hasValues([31, 33])) {
        val = Math.round((this.getFieldVal(31) / this.getFieldVal(33)) * 100);
      }
      this.setFieldVal(36, val);

      // 计算平均值
      this.calcAverage([24, 25, 26], 27);
      this.calcAverage([28, 29, 30], 31);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(2);
      }
      this.setFieldVal(z, res);
    },

    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      switch (curKey) {
        case "cell_41":
          config.form["cell_41_01"] = this.formData["cell_41_01"];
          config.form["cell_41_02"] = this.formData["cell_41_02"];
          config.form["cell_41_03"] = this.formData["cell_41_03"];
          config.form["cell_41_04"] = this.formData["cell_41_04"];
          config.form["cell_41_05"] = this.formData["cell_41_05"];
          config.form["cell_41_06"] = this.formData["cell_41_06"];
          config.form["cell_41_07"] = this.formData["cell_41_07"];
          config.form["cell_41_08"] = this.formData["cell_41_08"];
          config.form["cell_41_09"] = this.formData["cell_41_09"];
          config.form["cell_41_10"] = this.formData["cell_41_10"];
          config.form["cell_41_11"] = this.formData["cell_41_11"];
          break;
        case "cell_44":
          // config.form["cell_41_01"] = this.formData["cell_41_01"]
          // config.form["cell_41_02"] = this.formData["cell_41_02"]
          config.form["cell_44_03"] = this.formData["cell_44_03"];
          config.form["cell_44_04"] = this.formData["cell_44_04"];
          config.form["cell_44_05"] = this.formData["cell_44_05"];
          config.form["cell_44_06"] = this.formData["cell_44_06"];
          config.form["cell_44_07"] = this.formData["cell_44_07"];
          config.form["cell_44_08"] = this.formData["cell_44_08"];
          config.form["cell_44_09"] = this.formData["cell_44_09"];
          config.form["cell_44_10"] = this.formData["cell_44_10"];
          config.form["cell_44_11"] = this.formData["cell_44_11"];
          break;
        default:
          for (let key in this.formData) {
            if (key.indexOf(curKey) >= 0) {
              config.form[key] = this.formData[key];
            }
          }
      }
      this.popupConfig = config;
      console.log(config, '*****************************');
      this.popupVisible = true;
    },
    getMiddleValue(list, modulus, call) {
      const type = Object.prototype.toString.call(call);
      //如果call为函数，则
      if (type === "[object Function]") {
        list = list.map((v, i) => call(v, i));
      }
      list = list.sort((a, b) => a - b);
      const min = list.shift();
      const median = list.shift();
      const max = list.shift();
      let value = median;
      if (Math.abs(min - median) > modulus && Math.abs(max - median) > modulus) {
        value = 0;
      } else if (Math.abs(min - median) <= modulus && Math.abs(max - median) <= modulus) {
        value = (min + median + max) / 3;
      }
      return value;
    },
    roundOffMethod(value, modulus) {
      return Math.round(value / modulus) * modulus;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      let res1 = "";
      let res2 = "";
      let res3 = "";
      let res4 = "";
      let res5 = "";
      switch (this.curKey) {
        case "cell_32":
          if (this.hasValues(form, ["32_p01", "32_p02", "32_p03"])) {
            res = ((this.getFieldVal("32_p01", false, form) + this.getFieldVal("32_p02", false, form) + this.getFieldVal("32_p03", false, form)) / 3).toFixed(2);
          }
          this.setFieldVal(32, res);
          this.getChanges();
          break;
        case "cell_33":
          if (this.hasValues(form, ["33_p01", "33_p02", "33_p03"])) {
            res = ((this.getFieldVal("33_p01", false, form) + this.getFieldVal("33_p02", false, form) + this.getFieldVal("33_p03", false, form)) / 3).toFixed(2);
          }
          this.setFieldVal(33, res);
          this.getChanges();
          break;
        case "cell_41":
          if (this.hasValues(form, ["41_03", "41_04", "41_05"])) {
            res1 = this.getMiddleValue([this.getFieldVal("41_03", false, form), this.getFieldVal("41_04", false, form), this.getFieldVal("41_05", false, form)], 30).toFixed(0);
            this.setFieldVal("41_09", res1);
          }
          if (this.hasValues(form, ["41_06", "41_07", "41_08"])) {
            res2 = this.getMiddleValue([this.getFieldVal("41_06", false, form), this.getFieldVal("41_07", false, form), this.getFieldVal("41_08", false, form)], 30).toFixed(0);
            this.setFieldVal("41_10", res2);
          }
          res = this.roundOffMethod(res1 - res2, 5);
          this.setFieldVal("41_11", res);
          break;
        case "cell_44":
          if (this.hasValues(form, ["44_03", "44_04", "44_05"])) {
            res1 = this.getMiddleValue([this.getFieldVal("44_03", false, form), this.getFieldVal("44_04", false, form), this.getFieldVal("44_05", false, form)], 30).toFixed(0);
            this.setFieldVal("44_09", res1);
          }
          if (this.hasValues(form, ["44_06", "44_07", "44_08"])) {
            res2 = this.getMiddleValue([this.getFieldVal("44_06", false, form), this.getFieldVal("44_07", false, form), this.getFieldVal("44_08", false, form)], 30).toFixed(0);
            this.setFieldVal("44_10", res2);
          }
          res = this.roundOffMethod(res1 - res2, 5);
          this.setFieldVal("44_11", res);
          break;
        case "cell_42":
          if (this.hasValues(form, ["42_p01", "42_p02"])) {
            res = ((this.getFieldVal("42_p01", false, form) / this.getFieldVal("42_p02", false, form)) * 100).toFixed(0);
          }
          this.setFieldVal("42_p03", res);
          break;
        case "cell_43":
          if (this.hasValues(form, ["43_p02", "43_p03", "43_p04"])) {
            res1 = this.roundOffMethod(this.getFieldVal("43_p02", false, form) - this.getFieldVal("43_p03", false, form), 5);
            this.setFieldVal("43_p04", res1);
          }
          if (this.hasValues(form, ["43_p05", "43_p06", "43_p07"])) {
            res2 = this.roundOffMethod(this.getFieldVal("43_p05", false, form) - this.getFieldVal("43_p06", false, form), 5);
            this.setFieldVal("43_p07", res2);
          }
          if (this.hasValues(form, ["43_p08", "43_p09", "43_p10"])) {
            res3 = this.roundOffMethod(this.getFieldVal("43_p08", false, form) - this.getFieldVal("43_p09", false, form), 5);
            this.setFieldVal("43_p10", res3);
          }
          res = this.getMiddleValue([res1, res2, res3], 10);
          res = this.roundOffMethod(res, 5);
          this.setFieldVal("43_p11", res);
          break;
        case "cell_45":
          if (this.hasValues(form, ["45_p01", "45_p02", "45_p03"])) {
            const sum = this.getFieldVal("45_p01", false, form) + this.getFieldVal("45_p02", false, form) + this.getFieldVal("45_p03", false, form);
            res1 = (sum / 3).toFixed(0);
            this.setFieldVal("45_p04", res1);
          }
          if (this.hasValues(form, ["45_p05", "45_p06", "45_p07"])) {
            const sum = this.getFieldVal("45_p05", false, form) + this.getFieldVal("45_p06", false, form) + this.getFieldVal("45_p07", false, form);
            res2 = (sum / 3).toFixed(0);
            this.setFieldVal("45_p08", res2);
          }
          res = ((res1 * 1) / (res2 * 1)).toFixed(0);
          this.setFieldVal("45", res);
          break;
        case "cell_46":
          if (this.hasValues(form, ["46_p01", "46_p02", "46_p03"])) {
            const sum = this.getFieldVal("46_p01", false, form) + this.getFieldVal("46_p02", false, form) + this.getFieldVal("46_p03", false, form);
            res = (sum / 3).toFixed(1);
          }
          this.setFieldVal("46_p04", res);
          break;
        case "cell_47":
          if (this.hasValues(form, ["47_p01", "47_p02"])) {
            res1 = ((this.getFieldVal("47_p01", false, form) - this.getFieldVal("47_p02", false, form)) / +this.getFieldVal("47_p01", false, form)).toFixed(1);
            this.setFieldVal("47_p03", res1);
          }
          if (this.hasValues(form, ["47_p04", "47_p05"])) {
            res2 = ((this.getFieldVal("47_p04", false, form) - this.getFieldVal("47_p05", false, form)) / +this.getFieldVal("47_p04", false, form)).toFixed(1);
            this.setFieldVal("47_p06", res2);
          }
          if (this.hasValues(form, ["47_p07", "47_p08"])) {
            res3 = ((this.getFieldVal("47_p07", false, form) - this.getFieldVal("47_p08", false, form)) / +this.getFieldVal("47_p07", false, form)).toFixed(1);
            this.setFieldVal("47_p09", res3);
          }
          res = ((res1 * 1 + res2 * 1 + res3 * 1) / 3).toFixed(0);
          this.setFieldVal("47_p10", res);
          break;
        case "cell_48":
          if (this.hasValues(form, ["48_p01", "48_p02"])) {
            res1 = ((this.getFieldVal("48_p01", false, form) - this.getFieldVal("48_p02", false, form)) / +this.getFieldVal("48_p01", false, form)).toFixed(1);
            this.setFieldVal("48_p03", res1);
          }
          if (this.hasValues(form, ["48_p04", "48_p05"])) {
            res2 = ((this.getFieldVal("48_p04", false, form) - this.getFieldVal("48_p05", false, form)) / +this.getFieldVal("48_p04", false, form)).toFixed(1);
            this.setFieldVal("48_p06", res2);
          }
          if (this.hasValues(form, ["48_p07", "48_p08"])) {
            res3 = ((this.getFieldVal("48_p07", false, form) - this.getFieldVal("48_p08", false, form)) / +this.getFieldVal("48_p07", false, form)).toFixed(1);
            this.setFieldVal("48_p09", res3);
          }
          res = ((res1 * 1 + res2 * 1 + res3 * 1) / 3).toFixed(0);
          this.setFieldVal("48_p10", res);
          break;
        case "cell_49":
          if (this.hasValues(form, ["49_p01", "49_p02", "49_p03", "49_p04"])) {
            res1 = (this.getFieldVal("49_p01", false, form) / ((this.getFieldVal("49_p02", false, form) / this.getFieldVal("49_p03", false, form)) * this.getFieldVal("49_p04", false, form))).toFixed(1);
            this.setFieldVal("49_p05", res1);
          }
          if (this.hasValues(form, ["49_p06", "49_p07", "49_p08", "49_p09"])) {
            res2 = (this.getFieldVal("49_p06", false, form) / ((this.getFieldVal("49_p07", false, form) / this.getFieldVal("49_p08", false, form)) * this.getFieldVal("49_p09", false, form))).toFixed(1);
            this.setFieldVal("49_p10", res2);
          }
          if (this.hasValues(form, ["49_p011", "49_p012", "49_p013", "49_p014"])) {
            res3 = (this.getFieldVal("49_p011", false, form) / ((this.getFieldVal("49_p012", false, form) / this.getFieldVal("49_p013", false, form)) * this.getFieldVal("49_p014", false, form))).toFixed(1);
            this.setFieldVal("49_p15", res3);
          }
          res4 = this.getMiddleValue([res1 * 1, res2 * 1, res3 * 1], 0.15).toFixed(1);
          this.setFieldVal("49_p16", res4);
          if (this.hasValues(form, ["49_p17", "49_p18", "49_p19", "49_p20"])) {
            res1 = (this.getFieldVal("49_p17", false, form) / ((this.getFieldVal("49_p18", false, form) / this.getFieldVal("49_p19", false, form)) * this.getFieldVal("49_p20", false, form))).toFixed(1);
            this.setFieldVal("49_p21", res1);
          }
          if (this.hasValues(form, ["49_p22", "49_p23", "49_p24", "49_p25"])) {
            res1 = (this.getFieldVal("49_p22", false, form) / ((this.getFieldVal("49_p23", false, form) / this.getFieldVal("49_p24", false, form)) * this.getFieldVal("49_p25", false, form))).toFixed(1);
            this.setFieldVal("49_p26", res1);
          }
          if (this.hasValues(form, ["49_p27", "49_p28", "49_p29", "49_p30"])) {
            res1 = (this.getFieldVal("49_p27", false, form) / ((this.getFieldVal("49_p28", false, form) / this.getFieldVal("49_p29", false, form)) * this.getFieldVal("49_p30", false, form))).toFixed(1);
            this.setFieldVal("49_p31", res1);
          }
          res5 = this.getMiddleValue([res1 * 1, res2 * 1, res3 * 1], 0.15).toFixed(1);
          this.setFieldVal("49_p32", res5);
          res = ((res4 * 1) / (res5 * 1)).toFixed(0);
          this.setFieldVal("49_p33", res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
